import { createSelector } from 'reselect'

const select = (state) => state.faqs

const selectFaqs = createSelector(select, (faqs) => faqs.faqs)

const selectFaqsFetching = createSelector(select, (faqs) => faqs.isFetchingFaqs)

const selectCategoriesFetching = createSelector(
  select,
  (faqs) => faqs.isFetching
)

const selectCategories = createSelector(select, (faqs) => faqs.categories)

export {
  selectFaqs,
  selectFaqsFetching,
  selectCategories,
  selectCategoriesFetching
}
